import { ASSET_PATHS } from '../../utils/assetPath';

interface EyeOffIconProps {
  /**
   * Additional CSS class names
   */
  className?: string;
  /**
   * Size of the icon in pixels
   */
  size?: number;
  /**
   * Aria label for accessibility
   */
  ariaLabel?: string;
}

/**
 * EyeOffIcon component
 *
 * Displays an eye-off icon for visibility toggle (hide content).
 *
 * @example
 * <EyeOffIcon />
 * <EyeOffIcon size={20} ariaLabel="Hide password" />
 */
function EyeOffIcon({ className = '', size = 20, ariaLabel = 'Hide' }: EyeOffIconProps) {
  return (
    <img
      alt=''
      aria-label={ariaLabel}
      className={`eye-off-icon ${className}`}
      height={size}
      src={ASSET_PATHS.EYE_OFF_ICON}
      width={size}
    />
  );
}

export default EyeOffIcon;
